import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import getGridWidthClass from '../../utils/getGridWidthClass';
import dayjs from 'dayjs';
import InputText from '../InputText';
import InputDateRange from '../InputDateRange';
import InputMultiSelect from '../InputMultiSelect';
import InputLabelWrapper from '../InputLabelWrapper';
import SidebarNavigation from '../SidebarNavegation';

const localStr = localStorage.getItem('usuario');
const session = localStr ? JSON.parse(localStr) : null;
const vistasUsuario: string[] = session ? session.user.vistas : [''];
const tiposUsuario: string = session ? session.user.role : '';

interface ModalityFilterType {
  value: string;
  label: string;
}

const modalityFilters: ModalityFilterType[] = [
  // { value: 'MG', label: 'MAMOGRAFIA' },
  // { value: 'CT', label: 'TOMOGRAFIA' },
  // { value: 'MR', label: 'RESONANCIA' },
  // { value: 'US', label: 'ULTRASONIDO' },
  { value: 'DX', label: 'RAYOS X' },
  // { value: 'DOC', label: 'DOC' },
];

const StudyListFilterAside = ({ filtersMeta, filterValues, onChange, numOfStudies }) => {
  const { t } = useTranslation('StudyList');
  const { sortBy, sortDirection } = filterValues;
  const filterSorting = { sortBy, sortDirection };

  const setFilterSorting = sortingValues => {
    onChange({
      ...filterValues,
      ...sortingValues,
    });
  };

  const isSortingEnabled = true;
  const [isModalOpen, setIsModalOpen] = useState(false);

  // ⚠ INICIALIZACIÓN DE VALORES POR DEFECTO PARA 'studyDate' Y 'modalities'
  // Se aplican cuando:
  //   • El usuario abre la app por primera vez (pestaña nueva → sessionStorage vacío).
  //   • Pasaron más de 10 minutos de inactividad (timestamp expirado).
  //   • El usuario cierra la pestaña y la vuelve a abrir (sessionStorage se limpia solo).
  // NO se aplican cuando el usuario regresa desde el Viewer (botón ←) dentro
  // de los 10 minutos, preservando sus filtros personalizados.
  useEffect(() => {
    const INIT_KEY = 'filtersInitialized';
    const EXPIRY_MS = 10 * 60 * 1500; // 10 minutos

    const stored = sessionStorage.getItem(INIT_KEY);
    const now = Date.now();

    // Si la bandera existe Y no ha expirado → salir sin tocar nada.
    if (stored && now - Number(stored) < EXPIRY_MS) {
      return;
    }

    const defaultStartDate = dayjs().subtract(0, 'days');
    const defaultEndDate = dayjs();

    const shouldSetDefaultDate =
      !filterValues.studyDate ||
      !filterValues.studyDate.startDate ||
      !filterValues.studyDate.endDate;

    // Formateamos las fechas a 'YYYYMMDD'
    const formattedStartDate = defaultStartDate.format('YYYYMMDD');
    const formattedEndDate = defaultEndDate.format('YYYYMMDD');

    // Inicialización de modalidades
    let defaultModalities = [];
    if (vistasUsuario && vistasUsuario.length > 0) {
      defaultModalities = modalityFilters
        .filter(modality => vistasUsuario.includes(modality.label) || vistasUsuario.includes(modality.value))
        .map(modality => modality.value);
    } else {
      defaultModalities = ['DX'];
    }

    const modalityFilter = filtersMeta.find((f: any) => f.name === 'modalities');
    const shouldSetDefaultModalities = modalityFilter && (!filterValues.modalities || filterValues.modalities.length === 0);

    if (shouldSetDefaultDate || !filterValues.sortBy || shouldSetDefaultModalities) {
      const newFilterValues = { ...filterValues };

      if (shouldSetDefaultDate) {
        newFilterValues.studyDate = {
          startDate: formattedStartDate,
          endDate: formattedEndDate,
        };
      }
      if (!filterValues.sortBy) {
        newFilterValues.sortBy = 'studyDate';
        newFilterValues.sortDirection = 'ascending';
      }
      if (shouldSetDefaultModalities) {
        newFilterValues.modalities = defaultModalities;
      }

      onChange(newFilterValues);
    }

    // Guardar timestamp actual. Expirará en 10 min → próxima visita re-aplica defaults.
    sessionStorage.setItem(INIT_KEY, String(now));
  }, []);

  return (
    <>
      <SidebarNavigation onFilterToggle={() => setIsModalOpen(prev => !prev)} />
      {isModalOpen && (
        <div
          id="default-modal"
          aria-hidden="true"
          tabIndex={20}
          className="bg-primary-dark fixed inset-0 z-50 flex items-center justify-center bg-opacity-25 p-4"
        >
          <InputGroup
            inputMeta={filtersMeta}
            values={filterValues}
            onValuesChange={onChange}
            sorting={filterSorting}
            onSortingChange={setFilterSorting}
            isSortingEnabled={isSortingEnabled}
            closeButton={() => setIsModalOpen(prev => !prev)}
          />
        </div>
      )}
    </>
  );
};
// const StudyListFilterAside = ({ filtersMeta, filterValues, onChange, numOfStudies }) => {
//   const { t } = useTranslation('StudyList');
//   const { sortBy, sortDirection } = filterValues;
//   const filterSorting = { sortBy, sortDirection };
//   const setFilterSorting = sortingValues => {
//     onChange({
//       ...filterValues,
//       ...sortingValues,
//     });
//   };
//   const isSortingEnabled = numOfStudies > 0 && numOfStudies <= 100;
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   useEffect(() => {
//     const defaultModalities = modalityFilters
//       .filter(modality => vistasUsuario.includes(modality.label))
//       .map(modality => modality.value);
//     const modalityFilter = filtersMeta.find((f: any) => f.name === 'modalities');
//     if (modalityFilter && !filterValues.modalities?.length) {
//       onChange({
//         ...filterValues,
//         modalities: defaultModalities,
//       });
//     }
//   }, []);

//   return (
//     <>
//       <SidebarNavigation onFilterToggle={() => setIsModalOpen(prev => !prev)} />
//       {isModalOpen && (
//         <div
//           id="default-modal"
//           aria-hidden="true"
//           tabIndex={20}
//           className="fixed inset-0 z-50 flex items-center justify-center bg-blue-700 bg-opacity-25 p-4"
//         >
//           <InputGroup
//             inputMeta={filtersMeta}
//             values={filterValues}
//             onValuesChange={onChange}
//             sorting={filterSorting}
//             onSortingChange={setFilterSorting}
//             isSortingEnabled={isSortingEnabled}
//             closeButton={() => setIsModalOpen(prev => !prev)}
//           />
//         </div>
//       )}
//     </>
//   );
// };

const InputGroup = ({
  inputMeta,
  values,
  onValuesChange,
  sorting,
  onSortingChange,
  isSortingEnabled,
  closeButton,
}) => {
  const { sortBy, sortDirection } = sorting;
  const [isExpanded, setIsExpanded] = useState(false);
  const [filtroDesktop, setFiltroDesktop] = useState(false);

  const handleFilterLabelClick = name => {
    if (!isSortingEnabled) {
      return;
    }

    let _sortDirection = 'descending';
    if (sortBy === name) {
      _sortDirection = sortDirection === 'ascending' ? 'descending' : 'ascending';
    }

    onSortingChange({
      sortBy: _sortDirection !== 'none' ? name : '',
      sortDirection: _sortDirection,
    });
  };

  const renderFieldInputComponent = ({ name, displayName, inputProps, isSortable, inputType }) => {
    const _isSortable = isSortable && isSortingEnabled;
    const _sortDirection = sortBy !== name ? 'none' : sortDirection;

    const onLabelClick = () => handleFilterLabelClick(name);

    const handleFieldChange = newValue => {
      onValuesChange({
        ...values,
        [name]: newValue,
      });
    };
    const handleDateRangeFieldChange = ({ startDate, endDate }) => {
      onValuesChange({
        ...values,
        [name]: { startDate, endDate },
      });
    };
    switch (inputType) {
      case 'Text':
        return (
          <InputText
            key={name}
            id={name}
            label={displayName}
            isSortable={_isSortable}
            sortDirection={_sortDirection}
            onLabelClick={onLabelClick}
            value={values[name]}
            onChange={handleFieldChange}
          />
        );
      case 'MultiSelect':
        return (
          <InputMultiSelect
            className={''}
            key={name}
            id={name}
            label={displayName}
            isSortable={_isSortable}
            sortDirection={_sortDirection}
            onLabelClick={onLabelClick}
            value={values[name]}
            onChange={handleFieldChange}
            options={inputProps.options}
          />
        );
      case 'DateRange':
        return (
          <InputDateRange
            key={name}
            id={name}
            label={displayName}
            isSortable={_isSortable}
            sortDirection={_sortDirection}
            onLabelClick={onLabelClick}
            value={values[name]}
            onChange={handleDateRangeFieldChange}
          />
        );
      case 'None':
        return (
          <InputLabelWrapper
            key={name}
            className="max-sm:hidden"
            label={displayName}
            isSortable={_isSortable}
            sortDirection={_sortDirection}
            onLabelClick={onLabelClick}
          />
        );
      default:
        return null;
    }
  };
  return (
    <div className="bg-primary-main overflow-hidden rounded-xl p-4 shadow-sm">
      {/* Encabezado */}
      <div className="px-6 pt-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="rounded-lg p-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                fill="currentColor"
                className="bi bi-funnel-fill text-white"
                viewBox="0 0 16 16"
              >
                <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5z" />
              </svg>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-200">Filtros de Búsqueda</h3>
            </div>
          </div>
          <button
            className="rounded p-2 text-2xl text-white hover:text-red-600"
            onClick={closeButton}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              fill="currentColor"
              className="bi bi-x-circle"
              viewBox="0 0 16 16"
            >
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
            </svg>
          </button>
        </div>
      </div>

      {/* Campos de filtros */}
      <div className={'max-sm:p-6 sm:px-6 sm:pt-6'}>
        <div
          className={classnames(
            'grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3',
            filtroDesktop ? 'hidden' : ''
          )}
        >
          {inputMeta.map((meta: any, index: number) => {
            return (
              <div
                key={meta.name}
                className={classnames(
                  'transition-all duration-300',
                  meta.name === 'instances' ? 'hidden' : '',
                  getGridWidthClass(meta.gridCol)
                )}
              >
                {renderFieldInputComponent(meta)}
              </div>
            );
          })}
          <div className="flex place-items-center justify-center gap-4">
            <button
              onClick={() => {
                onSortingChange({
                  sortBy: 'studyDate',
                  sortDirection: 'ascending',
                });
                closeButton();
              }}
              className="bg-primary-active text-primary-dark focus:ring-primary-active hover:bg-primary-light flex h-10 w-10 items-center justify-center rounded text-base font-semibold shadow transition-colors duration-200 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2"
              aria-label="Ordenar por Fecha"
              title="Ordenar por Fecha Descendiente"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-clock-history"
                viewBox="0 0 16 16"
              >
                <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.787-.62c.53.535.98 1.144 1.325 1.805l-.924.375a7.045 7.045 0 0 0-.535-.764zm.996 2.45a6.99 6.99 0 0 0-.154-.937l.951-.303c.123.407.21.826.26 1.256l-.988.077a7.042 7.042 0 0 0-.069-.093zm.18 2.053c-.024.161-.054.32-.09.476l.983.185a8.006 8.006 0 0 1-.223 1.12l-.946-.324a7.002 7.002 0 0 0-.083-.404.363.363 0 0 0-.097-.247l.456-.206zM2.867 3.259a7 7 0 0 0-.653.796l-.787-.62a8.02 8.02 0 0 1 1.325-1.805l.924.375c-.198.243-.377.5-.535.764l.142.155a.363.363 0 0 0 .114.285l-.53-.95zM1.97 5.709a7.01 7.01 0 0 0-.154.937l-.951.303a8.03 8.03 0 0 1 .26-1.256l.988-.077c.023.031.045.062.069.093l-.212.016a.363.363 0 0 0 .097.247l-.097-.263zM1.517 7.762c-.024.161-.054.32-.09.476l-.983.185a8.006 8.006 0 0 1 .223-1.12l.946.324c.028.134.056.268.083.404l.115-.17a.363.363 0 0 0-.294-.099zM8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                <path d="M8 4.5a.5.5 0 0 1 .5.5v3.25l2.75 1.75a.5.5 0 1 1-.5.866l-3-1.95A.5.5 0 0 1 8 8V5a.5.5 0 0 1 .5-.5" />
              </svg>
            </button>
            <button
              onClick={closeButton}
              className="bg-primary-active text-primary-dark focus:ring-primary-active hover:bg-primary-light h-10 w-32 rounded px-4 py-2 text-base font-semibold shadow transition-colors duration-200 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2"
              aria-label="Buscar"
            >
              Buscar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

InputGroup.propTypes = {
  inputMeta: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      displayName: PropTypes.string.isRequired,
      inputType: PropTypes.oneOf(['Text', 'MultiSelect', 'DateRange', 'None']).isRequired,
      isSortable: PropTypes.bool.isRequired,
      gridCol: PropTypes.number.isRequired,
      inputProps: PropTypes.object,
    })
  ).isRequired,
  values: PropTypes.object.isRequired,
  onValuesChange: PropTypes.func.isRequired,
  sorting: PropTypes.shape({
    sortBy: PropTypes.string,
    sortDirection: PropTypes.oneOf(['ascending', 'descending', 'none']),
  }).isRequired,
  onSortingChange: PropTypes.func.isRequired,
  isSortingEnabled: PropTypes.bool.isRequired,
};

StudyListFilterAside.propTypes = {
  filtersMeta: PropTypes.arrayOf(
    PropTypes.shape({
      /** Identifier used to map a field to it's value in `filterValues` */
      name: PropTypes.string.isRequired,
      /** Friendly label for filter field */
      displayName: PropTypes.string.isRequired,
      /** One of the supported filter field input types */
      inputType: PropTypes.oneOf(['Text', 'MultiSelect', 'DateRange', 'None']).isRequired,
      isSortable: PropTypes.bool.isRequired,
      /** Size of filter field in a 12-grid system */
      gridCol: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]).isRequired,
      /** Options for a "MultiSelect" inputType */
      option: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string,
          label: PropTypes.string,
        })
      ),
    })
  ).isRequired,
  filterValues: PropTypes.object.isRequired,
  numOfStudies: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  isFiltering: PropTypes.bool.isRequired,
  onUploadClick: PropTypes.func,
  getDataSourceConfigurationComponent: PropTypes.func,
};

export default StudyListFilterAside;
